import { render, staticRenderFns } from "./backGroundCom.vue?vue&type=template&id=b1f71648&scoped=true"
import script from "./backGroundCom.vue?vue&type=script&lang=js"
export * from "./backGroundCom.vue?vue&type=script&lang=js"
import style0 from "./backGroundCom.vue?vue&type=style&index=0&id=b1f71648&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1f71648",
  null
  
)

export default component.exports